module.exports = __webpack_public_path__ + "static/export5-min-d7fe204be23358f53520fde448284a4c.png";